import React, { useState } from 'react';
import { IBackgroundImages } from 'api/home/types';
import { sendMessageToAiAssistant } from 'util/sendMessageToAiAssistant';
import styles from './style.module.scss';

export const AiHomeHero = ({
  backgroundImage,
  suggestions = [],
}: {
  backgroundImage: IBackgroundImages;
  suggestions?: string[];
}) => {
  const [inputValue, setInputValue] = useState('');

  const handleSend = () => {
    if (inputValue.trim()) {
      sendMessageToAiAssistant(inputValue);
      setInputValue('');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleSuggestionClick = (text: string) => {
    sendMessageToAiAssistant(text);
  };

  return (
    <header
      className={styles.hero}
      style={{ backgroundImage: `url("${backgroundImage.image}")` }}
    >
      <div className={styles.overlay} />

      <div className={styles.container}>
        <div className={styles.titleRow}>
          <img
            className={styles.snowflakeIcon}
            src="/assets/ai-assistant-logo.svg"
            alt="SkiGPT"
          />
          <h2 className={styles.title}>Meet SkiGPT, your personal AI assistant</h2>
        </div>

        <div className={styles.searchBox}>
          <textarea
            className={styles.searchInput}
            placeholder="Planning your next day on the mountain? Ask about fresh powder, weather changes, or the best places to ride."
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            maxLength={450}
          />
          <button type="button" className={styles.sendButton} onClick={handleSend}>
            <img src="/assets/icons/send-icon.svg" alt="Send message to SkiGPT" />
          </button>
        </div>

        {suggestions.length > 0 && (
          <div className={styles.suggestions}>
            {suggestions.map((text) => (
              <button
                key={text}
                type="button"
                className={styles.pill}
                onClick={() => handleSuggestionClick(text)}
              >
                {text}
              </button>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};
